import { palette } from '@app/src/theme/palette'
import type { Palette } from '@mui/material/styles'
import type { ItemStyleOption } from '@app/src/types/echarts'

export const colors = [
  '#F6918D',
  '#F6AD63',
  '#6BBFCC',
  '#C94087',
  '#2E22CD',
  '#FF9AD1',
  '#F7CCCA',
  '#7E95F6',
  '#D37745',
  '#AE320F',
  '#234404',
  '#046E17',
  '#D8C324',
  '#1393A1',
  '#1964F4',
  '#3E4B9D',
  '#041678',
  '#CE5EDF',
  '#D1A3F3',
  '#6B2E0C',
  '#07677C',
  '#C0AA82',
]

export const REPORTED_COLOR = palette.visualization['5']
export const DONT_HAVE_THIS_COLOR = palette.warning.dark
export const notAnsweredStyling = (palette: Palette) => ({
  color: notAnsweredColor(palette),
  itemStyle: stripedGreyDecal(palette),
})

export const notAnsweredColor = (palette: Palette) => palette.grey['500']
export const stripedGreyDecal = (palette: Palette): ItemStyleOption => ({
  decal: {
    color: notAnsweredColor(palette),
    backgroundColor: 'white',
    dashArrayX: [1, 0],
    dashArrayY: [1, 3],
    symbolSize: 2,
    rotation: (3 * Math.PI) / 4,
  },
})

/** The same stripes as stripedGreyDecal, as a CSS background for elements outside a chart, where decals do not apply. */
export const notAnsweredBackground = (palette: Palette): string =>
  `repeating-linear-gradient(135deg, ${notAnsweredColor(palette)} 0 1px, ${palette.common.white} 1px 4px)`

export const NOT_SELECTED_COLOR = '#D3D3D3'
export const NOT_SELECTED_GROUP_NAME = 'Not selected'
